/**
 * Short-form city aliases.
 * Each short slug 301-redirects (canonical + meta-refresh) to the full canonical city slug.
 *
 * Why aliases instead of changing the canonical slug?
 * - Canonical slugs follow INSEE naming (legally correct, used in official directories).
 * - Short forms match real user search behavior on Google.
 * - Redirect preserves the SEO value of the canonical page while capturing the short-form traffic.
 *
 * NOT added to sitemap.xml (Google should only index the canonical URL).
 */

export const CITY_ALIASES = {
    // Hauts-de-Seine
    "neuilly": "neuilly-sur-seine",
    "boulogne": "boulogne-billancourt",
    "asnieres": "asnieres-sur-seine",
    "issy": "issy-les-moulineaux",
    "rueil": "rueil-malmaison",
    "chatenay": "chatenay-malabry",
    // Val-de-Marne
    "saint-maur": "saint-maur-des-fosses",
    "charenton": "charenton-le-pont",
    // Yvelines
    "saint-germain": "saint-germain-en-laye",
};

/** Build all alias URL paths (for routing + react-snap include). */
export function allCityAliasPaths() {
    return Object.keys(CITY_ALIASES).map((shortSlug) => `/reparateur-electromenager-${shortSlug}`);
}

export function findCanonicalCitySlug(shortSlug) {
    return CITY_ALIASES[shortSlug] || null;
}
